
import { Component, Prop, Vue } from "vue-property-decorator";
import FinderVue from "@/finder/Finder.vue";
import  ButtonVue from "@/lib/Button.vue";
import { Next, Route } from 'vue-router';

import { Debouncer } from "@/lib/Debouncer";
import  ClipAddMultiVue from "@/clip/ClipAddMulti.vue";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();
import { IEdiPO } from "../../server/src/edi/IEdiPO"
import { CheckSupplier } from "../../server/src/edi/CheckSupplier";

import { IEdiPOItem } from "../../server/src/edi/IEdiPOItem"
import { ObjEvents } from "../../server/src/mqtt/ObjEvents";
import { IUser } from "server/src/user/IUser";

 @Component({
        async beforeRouteEnter(to: Route, from: Route, next: Next<POConfirmationVue>) {
            //const porders = await bus.api("/api/edi/list_po_confirmations",{})
            //console.log(porders)
            next((vm: POConfirmationVue) => {
              //if (porders) vm.porders = porders;
              //else 
              vm.porders=[]
            });
        },

      components: { FinderVue, ButtonVue,ClipAddMultiVue }
})
export default class POConfirmationVue extends Vue {
    user:IUser=bus.get_user();
    filter:string="";
    porders: any[]=[];
    key:number=1;
    debounced:any
    selected_po :IEdiPO|undefined
    selected_po_key=0
    
    kontrahenci:any = CheckSupplier.ids
    kontrahent_id = CheckSupplier.getRaflatacIDs()[0] // Raflatac

    
    async mounted() {
      (<any>this.selected_po) = {PO_id_customer: 0 }
  
      const kid=localStorage.getItem('kontrahent_id')
      if (kid) this.kontrahent_id=parseInt(kid)
      this.kontrahent_selected()

      bus.register(ObjEvents.list_status_changed, this.list_status_changed);
      //this.debounced = Debouncer.debounce(await (this._chg.bind(this)), 1000).bind(this);
      if (this.porders && this.porders[0]) this.select_po(this.porders[0]) 
    }

    kontrahent_selected() {
      if (this.kontrahent_id !== null) {
        const selectedName = this.kontrahenci[this.kontrahent_id];
        console.log("Selected Kontrahent ID:", this.kontrahent_id);
        localStorage.setItem('kontrahent_id',this.kontrahent_id.toString())
        this._chg()
      }
    }

    async beforeDestroy() {
      bus.remove(ObjEvents.list_status_changed, this.list_status_changed);
    }

    async list_status_changed(e:any) {
      console.log("list_status_changed: po_confirmation")
      
      const obj = e.detail;
      if (obj.type!="po_confirmation") return;
      console.log("list_status_changed: po_confirmation")
      const ret=await this._chg()
      
    }


    async chg() {
    if (!this.debounced) return;
    await this.debounced();
  }

  async _chg() {
    if (!this.kontrahent_id) return;
    this.porders = await bus.api("/api/edi/list_po_confirmations",{ kontrahent_id: this.kontrahent_id, kontrahent_idn: this.kontrahenci[this.kontrahent_id]})
    if (this.porders && this.porders[0]) this.select_po(this.porders[0]) 
    else this.porders=[]
    this.key++;
    return this.porders
  }
  async download_and_process_order_confirmations() {
    const ret=await bus.call("/api/edi/download_and_process_po_confirmations",{ download: true, kontrahent_id: this.kontrahent_id, kontrahent_idn: this.kontrahenci[this.kontrahent_id]})
    await this._chg()
    console.log(ret)
  }

  async process_order_confirmations() {
    const ret=await bus.call("/api/edi/download_and_process_po_confirmations",{ download: false, kontrahent_id: this.kontrahent_id, kontrahent_idn: this.kontrahenci[this.kontrahent_id]})
    console.log(ret)
    await this._chg()
  }

  select_po(p:IEdiPO) {
    this.selected_po = p
    if (p) this.selected_po_key++
  }

  showPOHistory(PO_id: number) {
    window.router.push({ path: `/POHistory/${PO_id}` }) 
  }
}




